import { Tab } from '../../../../../modals/modifier/ModifierModal';

export default {
  title: 'Novo modificador',
  tabs: {
    [Tab.General]: 'Geral',
    [Tab.NutritionInfo]: 'Informação nutricional',
  },
  form: {
    modifier_groups: {
      label: 'Pertence a grupos de modificadores',
    },
    name: {
      label: 'Nome',
      placeholder: 'Ketchup',
    },
    external_id: {
      label: 'Ref {{integration}}',
      placeholder: 'ex.: referência SKU HubRise',
      read_only_hint:
        'Editável apenas quando uma integração HubRise está ligada e a sincronização do menu está desativada.',
    },
    price: {
      label: 'Preço base',
      placeholder: 'Opcional',
    },
    is_available: {
      label: 'Em stock',
    },
    is_visible: {
      label: 'Visível',
      title: 'Visível no menu',
      subtitle_on: 'Os clientes podem ver esta opção',
      subtitle_off: 'Oculto de todos os clientes',
    },
    is_available_for_pickup: {
      label: 'Disponível para takeaway',
      subtitle_on: 'Os clientes podem encomendar para takeaway',
      subtitle_off: 'Oculto do menu de takeaway',
    },
    is_available_for_delivery: {
      label: 'Disponível para entrega',
      subtitle_on: 'Os clientes podem encomendar para entrega',
      subtitle_off: 'Oculto do menu de entrega',
    },
  },
  availability: {
    title: 'Disponibilidade',
    helper:
      'A visibilidade é o interruptor principal. Desative um canal para ocultar esta opção dos clientes de takeaway ou entrega sem a remover do menu.',
    status: {
      both: 'Ambos os canais',
      pickup_only: 'Apenas takeaway',
      delivery_only: 'Apenas entrega',
      hidden: 'Oculto',
      no_channels: 'Sem canais',
    },
    warning: {
      no_channels:
        'Esta opção é visível mas não está disponível em nenhum canal — os clientes não poderão selecioná-la.',
    },
    placeholder: '—',
    list_badge: {
      pickup_only: 'Apenas takeaway',
      delivery_only: 'Apenas entrega',
      no_channels: 'Sem canais',
    },
  },
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    changes_got_saved: 'Alterações guardadas com sucesso!',
  },
};
